//
import { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import withImmutablePropsToJS from "with-immutable-props-to-js"

import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups"
import {
    generateGrassrootsActionCenterFilter,
    generateGrassrootsActionCampaignFilter,
    generateGANotInCampaignFilter,
} from "shared/search/containers/Filter/Filters"
import { selectCurrentDeserializedFilters } from "shared/search/selectors"
import { GrassrootsActionApprovedFilter } from "shared/search/containers/Filter/GrassrootsActionFilters"
import { parseAndGenerateGrassrootsActionCenterFilters } from "shared/search/components/FilterableListView/helperFunctions"

export const createGACampaignFilterGroup = () => {
    const mapStateToProps = (state, props) => ({
        currentFilters: selectCurrentDeserializedFilters(state, props),
    })

    class GACampaignFilterGroup extends Component {
        render() {
            const selectedActionCenters =
                this.props.currentFilters &&
                this.props.currentFilters.for_action_centers &&
                this.props.currentFilters.for_action_centers.addedIds

            return genericFilterGroup({
                filters: [
                    ...(!Userdata.has_singular_action_center
                        ? [
                              generateGrassrootsActionCenterFilter({
                                  uniqueFilterId: "gaActionCenterFilter",
                                  filterKey: "for_action_centers",
                              }),
                          ]
                        : []),
                    generateGrassrootsActionCampaignFilter(selectedActionCenters),
                    generateGANotInCampaignFilter(selectedActionCenters),
                    GrassrootsActionApprovedFilter,
                ],
                uniqueFilterGroupId: "gaCampaignFilterGroup",
                displayLabel: "Campaign",
                helpText: "Filter actions by your grassroots campaigns.",
                ...this.props,
            })
        }
    }

    GACampaignFilterGroup.propTypes = {
        currentFilters: PropTypes.object,
    }

    const connectedFilterGroup = connect(mapStateToProps, null)(withImmutablePropsToJS(GACampaignFilterGroup))

    Object.assign(connectedFilterGroup, {
        defaultProps: {
            filterKeyMap: {
                gaActionCenterFilter: "for_action_centers",
                gaCampaignFilter: "for_campaigns",
                gaNotInCampaignFilter: "not_for_campaigns",
                grassrootsActionApprovedFilter: "campaign_confirmed",
            },
            isConnectedFilterGroup: true,
            uniqueFilterGroupId: "gaCampaignFilterGroup",
            parseFunction: parseAndGenerateGrassrootsActionCenterFilters,
        },
    })

    return connectedFilterGroup
}
